export default __webpack_public_path__ + "static/time-e61ed19edad4926dbb60668f6c8fc225.png";